import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../../components/common/List/Custom-List_layout";
import Convertdate from "../../../components/common/List/Converdate";
import { useGetAppointmentsQuery } from '../../../store/api/appointmentApi';
import ConfirmationModal from "../../../components/common/List/DeletePopup";

const AppointmentList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValues, setFilterValues] = useState({});
  const [sortKey, setSortKey] = useState("created_at");
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});

  const { data: tabledata, isLoading, refetch } = useGetAppointmentsQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
    ...filterValues,
  });

  useEffect(() => {
    refetch();
  }, [currentPage, pageSize, sortKey, filterValues, refetch]);

  // ✅ Table Headers
  const tableHeaders = [
    { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
    { label: "User Name", key: "user_name", sortable: true },
    { label: "Email", key: "user_email", sortable: true },
    { label: "Gym Name", key: "gym_name", sortable: true },
    { label: "Start Date", key: "start_date", render: (value) => <Convertdate date={value} /> },
    { label: "End Date", key: "end_date", render: (value) => value ? <Convertdate date={value} /> : "—" },
    { label: "Appointment Time", key: "appointment_time" },
    {
      label: "Status",
      key: "status",
      sortable: true,
      render: (value) => {
        let bgColor = "bg-gray-200 text-gray-800";
        if (value === "approved") bgColor = "bg-green-200 text-green-800";
        else if (value === "pending") bgColor = "bg-yellow-200 text-yellow-800";
        else if (value === "requested") bgColor = "bg-blue-200 text-blue-800";
        else if (value === "rejected") bgColor = "bg-red-200 text-red-800";

        return (
          <span className={`px-2 py-1 rounded-full text-sm font-medium ${bgColor}`}>
            {value}
          </span>
        );
      }
    },
    { label: "Created At", key: "created_at", render: (value) => <Convertdate date={value} /> },
  ];

  // ✅ Filters
  const filters = [
    { key: "gym_name", type: "text", placeholder: "Gym Name" },
    { key: "user_name", type: "text", placeholder: "User Name" },
    { key: "status", type: "text", placeholder: "Status" },
    { key: "created_at", type: "date", placeholder: "Created On" },
  ];

  const filterComponents = filters.map((filter) => ({
    ...filter,
    value: filterValues[filter.key] || "",
  }));

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  // ✅ Action Buttons (same style as vendor)
  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      onClick: (row) =>
        navigate(`/appointmentview/${row.id}`, { state: { data: row, pageName: "APPOINTMENT" } }),
    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) =>
        navigate(`/appointment-edit/${row.id}`, { state: { data: row, pageName: "APPOINTMENT" } }),
    },
    
  ];

  const handleDelete = async () => {
    try {
      // Delete API call here
      setIsModalOpen(false);
      refetch();
    } catch (error) {
      refetch();
    }
  };

  return (
    <>
      <ListLayout
        title="Appointment List"
        filterComponents={filterComponents}
        onFilterChange={handleFilterChange}
        tableHeaders={tableHeaders}
        tabledata={tabledata?.results || []}
        actionButtons={actionButtons}
        currentPage={currentPage}
        totalrecords={tabledata?.count}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSort={(key) => setSortKey(key)}
        sortKey={sortKey}
        isLoading={isLoading}
      />

      {isModalOpen && (
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};

export default AppointmentList;
